<template>
    <div class="square-container-3">
        <div class="main-square-3">
            <br>
            <div class="header-section3-3">
                <div class="header-title-3">Function: Transfer (MyERC20)</div>
                <div class="header-title-3">Rating: 91/100</div>
                <div class="header-sub-3">




                </div>
                <div class="header-content-3">




                </div>


            </div>
            <div class="section1-3">
                <div class="section1-head-3">Function Information</div>
                <br>
                <div class="section1-titles-3">

                    <div class="audit-3">Description: </div>


                </div>

                <div class="section1-content-3">
                    <div>This Function is used to transfer a given amount of the MYERC20 token from one address to another.
                    </div>



                </div>
                <div class="button-container-3">
                    <button class="info-button">Build Transaction</button>
                    <button class="info-button">Comments</button>
                    <button class="info-button">Events</button>
                    <button class="info-button">More Info</button>
                    <button class="info-button">Visualizations</button>
                </div>
            </div>

            <div class="section2-3">
                <br>
                <div class="section1-titles-3">
                    <br>
   

                </div>

                <div class="section1-content-30">
                    <br><br>
                    <br>
                    <div> From: 
                        <input type="text" placeholder="Address" class="input-field">
                    </div>
                    <br><br>

                    <div>To: &nbsp;&nbsp;
                        <input type="text" placeholder="Address" class="input-field">
                    </div>
                    <br><br>
                    <div>Value:
                        <input type="text" placeholder="uint256" class="input-field">
                    </div>
                    <br>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <button> Confirm</button>
                </div>
                

                <!-- <div class="params-container">
                    <div class="function-names" v-for="(input, index) in clickedFunction.inputs" :key="index">{{ input.name
                    }}
                        <template v-if="input.type === 'address'">
                            <textBox />
                        </template>

                        <template v-if="input.type === 'bool'">
                            <radioButton />
                        </template>

                        <template v-if="input.type === 'uint256'">
                            <uint256Box />
                        </template>

                        <template v-if="input.type === 'hex'">
                            <hexTextBox />
                        </template>



                    </div>
                    this is mvp functionality and technical debt, 
                    <div v-if="stateTypes === 'nonpayable'"> 
                        <UniSwapTrade />
                    </div>

                    <div v-if="stateTypes === 'view'">
                        <SendToken />
                    </div>
                    <div v-if="stateTypes === 'payable'">
                        <SwapThree />
                    </div>


                </div>

            -->
            </div>


        </div>
    </div>

    <VerificationPage v-if="showVerificationPage" :contractId="contractId" :functionIndex="functionIndex">
    </VerificationPage>
</template>
<script>
/*
import textBox from './textBox.vue';
import radioButton from './radioButton.vue';
import hexTextBox from './hexTextBox.vue';
import uint256Box from './uint256Box.vue';
import UniSwapTrade from './UniSwapTrade.vue';
import SendToken from './SendToken.vue';
import SwapThree from './SwapThree.vue';

*/

export default {
    components: {

        /*
        textBox,
        radioButton,
        hexTextBox,
        uint256Box,
        UniSwapTrade,
        SendToken,
        SwapThree,
        */


    },

    props: {
        contractId: {
            type: String,
            required: true
        },
        functionIndex: {

            required: true
        }
    },

    data() {
        return {

            contractAddress: '',
            inputNames: '',
            clickedFunction: [],

            selectedContractId: null

        };
    },
    mounted() {
        this.getContractData();
    },

    methods: {
        async getContractData() {



            const response = await fetch(`http://localhost:12345/api/v1/sourcify/${this.contractId}`); //0x0000000000003f5e74C1ba8A66b48E6f3d71aE82
            // const response = await fetch(`http://174.107.99.75:12345/api/v1/sourcify/0x0000000000003f5e74C1ba8A66b48E6f3d71aE82`);

            const data = await response.json();


            this.contractAddress = data._id;
            this.clickedFunction = data.output.abi[this.functionIndex];

            this.inputNames = this.clickedFunction.inputs.map(input => input.name)

            this.inputTypes = this.clickedFunction.inputs.map(input => input.type)

            this.typeName = this.clickedFunction.name

            /* console.log(this.typeName)

            console.log(this.clickedFunction)

            console.log(this.inputTypes) */

            this.stateTypes = this.clickedFunction.stateMutability

            console.log(this.stateTypes)

            console.log(this.contractId);

            console.log(this.functionIndex)


        }
    }
};

</script>

<style>
.square-container-3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.main-square-3 {
    width: 80%;
    height: 80%;
    bottom: 0%;

    border-radius: .5%;
    display: grid;
    grid-template-rows: 15% 45% 20% 20%;
    grid-template-columns: 100%;
    grid-template-areas:
        "header"
        "section1"
        "section2"
        "section3"




    ;
    position: relative;
}

/*.main-square-3 {
    width: 1200px;
    height: 900px;
    background-color: rgb(238, 238, 238);
    border-radius: 1%;
    display: grid;
    grid-template-rows: 15% 45% 20% 20%;
    grid-template-columns: 100%;
    grid-template-areas:
        "header"
        "section1"
        "section2"
        "section3"
    ;
    position: relative;
}

.main-square-3::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15%;
    border-bottom: 3px solid black;
}

.main-square-3::after {
    content: "";
    position: absolute;
    top: 0;
    left: 100%;
    width: 1px;
    top: 10%;
    height: 85%;


}
*/

.header-section3-3 {
    grid-area: header;



}

.header-title-3 {
    text-align: left;
    padding-top: .0%;
    font-weight: bold;
    font-size: 24pt;


}

.header-sub-3 {
    width: 15%;
    /* or another width that you prefer */
    float: left;
    clear: both;
    /* to make sure it starts below section1-head */
    text-align: left;
    padding-left: 2%;
    font-weight: bold;
}

.header-content-3 {
    width: 70%;
    /* or another width that you prefer */
    float: left;
    text-align: left;
}


.section1-3 {
    grid-area: section1;
    border-bottom: 3px solid black;
    width: 100%;
    border-top: 3px solid black;

}

.section1-head-3 {
    text-align: center;
    padding-top: .0%;
    font-weight: bold;
    font-size: 24pt;
}

.section1-titles-3 div,
.section1-content-3 div {
    margin-bottom: 20px;
    padding-top: 10pt;
}


.section1-titles-3 {
    width: 15%;
    /* or another width that you prefer */
    float: left;
    clear: both;
    /* to make sure it starts below section1-head */
    text-align: left;
    padding-left: 2%;
    font-weight: bold;


}

.section1-content-3 {
    width: 70%;
    /* or another width that you prefer */
    float: left;
    text-align: left;
}
.section1-content-3 {
    width: 70%;
    /* or another width that you prefer */
    float: left;
    text-align: Center;
}



.section2-3 {
    grid-area: section2;

    width: 100%;

}

.section2-titles-3 {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt;


}



.section3-3 {
    grid-area: section3;

    border-bottom-left-radius: 10px;

}

.section3-titles-3 {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt
}





.toAddress-text-3,
.amount-text-3 {
    margin: 10px auto;
    /* add some space between the inputs */
    width: 80%;
    /* adjust as needed */
    padding: 10px;
    /* add some padding for the text */
    border-radius: 4px;
    /* adjust as needed */
    font-size: larger;
    /* adjust as needed */
    border: 2px solid black;
    /* adjust as needed */
}

.toAddress-text-3 {

    margin-bottom: 30px;
    margin-top: 50px;
}

.amount-text-3 {
    margin-bottom: 10px;
}

.send-button-3 {
    margin: 50px;
    padding: 10px 50px;
    font-size: 2rem;
    border-radius: 5px;
    border: black;
    background-color: #000000;
    /* Green */
    color: rgb(255, 255, 255);
}

.function-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}

.function-name {

    padding: 10px;
}


.button-container-3 {
    position: absolute;
    top: 60%;
    right: 30%;
    transform: translateY(-50%);

}

.info-button {
    margin: 0 0px;
    border-radius: 0%;
    background-color: rgb(32, 31, 31);
    border-color: white;
    z-index: 2;
}
.input-field {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px 12px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease-in-out;
}

</style>